import { NgClass } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, OnDestroy, input, output, inject } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { StaffPreferences } from '@fitness-force/enum';
import type { StaffNotification, TENANTSINTERFACE } from '@fitness-force/models';
import { Store } from '@ngrx/store';
import { TENANTS_INFO } from '@fitness-force/state';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { DrawerModule } from 'primeng/drawer';
import { StaffNotificationComponent } from '@fitness-force/shared';
import { StaffAvailabilityComponent } from '@fitness-force/staff-availability-lib';
import { TranslateModule } from '@ngx-translate/core';
import { StaffDetailsComponent } from '@fitness-force/staff-lib';
import { SelectModule } from 'primeng/select';
import { MyCommissionComponent } from '@fitness-force/commission-management';
import { FeatureFlagService } from '@fitness-force/shared-utils';
import { Subject, takeUntil } from 'rxjs';


@Component({
  selector: 'staff-preferences',
  standalone: true,
  imports: [
    DrawerModule,
    ToggleSwitchModule,
    FormsModule,
    ReactiveFormsModule,
    StaffNotificationComponent,
    StaffAvailabilityComponent,
    TranslateModule,
    SelectModule,
    StaffDetailsComponent,
    MyCommissionComponent,
    NgClass
],
  templateUrl: './staff-preferences.component.html',
  styleUrl: './staff-preferences.component.css',
})
export class StaffPreferencesComponent implements OnInit, OnDestroy {
  cdr = inject(ChangeDetectorRef);
  private store = inject(Store);
  private featureFlagService = inject(FeatureFlagService);
  private readonly destroy$ = new Subject<void>();

  readonly showStaffPreferenceSidebar = input<boolean>(false, { alias: "showClientSidebar" });
  readonly activeStaffId = input<number>(0);
  readonly staffPreference = input<StaffPreferences>(StaffPreferences.Profile);
  readonly closeSidebar = output<boolean>();

  staffSubscribedNotification: StaffNotification = {} as StaffNotification;
  allNotifications: { key: string; label: string }[] = [];
  tenantAccess: any[] = [];
  tenantId: number = 0;
  companyId:number = 0;
  selectedPreference: StaffPreferences = this.staffPreference();
  showNotification: boolean = true;
  preferences: any[] = [];
  selectedPreferenceOption: any;
  constructor() {
    this.preferences = [
      {name: 'PROFILE', icon: 'fa fa-user', value: StaffPreferences.Profile, disabled: false},
      {name: 'NOTIFICATION', icon: 'fa fa-bell', value: StaffPreferences.Notification, disabled: false},
      {name: 'AVAILABILITY', icon: 'fa fa-calendar-days', value: StaffPreferences.Availability, disabled: false},
      {name: 'LANGUAGE', icon: 'fa fa-language', value: StaffPreferences.Language, disabled: true},
    ]
  }

  ngOnInit() {
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantAccess = tenant.accessed_tenant;
      this.tenantId = tenant.selected_tenant.id;
      this.companyId= tenant.selected_tenant.company_id;
    });
    // Staff notification feature flag is now handled by FeatureFlagService

    this.featureFlagService.getFlag$('show_commission_management').pipe(takeUntil(this.destroy$)).subscribe((showCommissionManagement) => {
      if(showCommissionManagement) {
        this.preferences.push({name: 'MY_COMMISSION', icon: 'fa fa-money-bill', value: StaffPreferences.Commission, disabled: false});
      }
      this.cdr.detectChanges();
    });
      this.selectedPreferenceOption = this.preferences.find(preference => preference.value === this.selectedPreference) || this.preferences[0];
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  selectPreferenceMobile(preference: any){
    const selectedpref = preference.value;
    this.selectedPreferenceOption = selectedpref;
    this.selectedPreference = selectedpref.value;
    this.cdr.detectChanges();
  }

  selectPreferenceDesktop(preference: any){
    this.selectedPreferenceOption = preference;
    this.selectedPreference = preference.value;
    this.cdr.detectChanges();
  }
  
  close() {
    this.closeSidebar.emit(true);
  }

  public get staffPreferences(): typeof StaffPreferences {
    return StaffPreferences;
  }

}
